import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'brandcase',
})
export class BrandCasePipe implements PipeTransform {
  transform(manufacturer: string, upperCaseBrands: string[]): string {
    if (!manufacturer) return '';

    const formattedManufacturer = upperCaseBrands.includes(manufacturer)
      ? manufacturer.toUpperCase()
      : manufacturer.charAt(0).toUpperCase() +
        manufacturer.slice(1).toLowerCase();

    return formattedManufacturer;
  }
}
